'use client'

import type { IconProps } from '@hedepy/icons/Icon'
import type * as Icons from '@hedepy/icons/refactor'
import { camelCase, upperFirst } from 'lodash'
import useSWRImmutable from 'swr/immutable'
import type { KebabCase, PascalCase } from 'type-fest'

import { cn } from '@/legacy-src/lib/utils'

export interface LazyIconProps extends Omit<IconProps, 'name'> {
  name: KebabCase<keyof typeof Icons>
}

export function pascalCase<T extends string>(str: T) {
  return upperFirst(camelCase(str)) as PascalCase<T>
}

const fetchIcon = async (name: LazyIconProps['name']) => {
  return import('@hedepy/icons/refactor').then((module) => module[pascalCase(name)])
}

export const LazyIcon = ({ name, ...props }: LazyIconProps) => {
  const { data: Icon, isLoading } = useSWRImmutable([name, 'LazyIcon'], async () => {
    return await fetchIcon(name)
  })

  if (isLoading || !Icon) {
    return (
      <span
        className={cn('block rounded-md bg-sand-100', props.className)}
        style={
          props.size === 'auto'
            ? undefined
            : {
                width: props.size ?? 24,
                height: props.size ?? 24,
              }
        }
      />
    )
  }

  return <Icon {...props} />
}
